import React from 'react'
import { BASE_URL } from '../../utils'
/*
A reusable page wrapper for the Header
 */
const Header = ({
  iconClass,
  title,
  docLink,
  description,
  children,
  headerClassName = 'secondary-page-title',
  headerChildren,
}) => {
  return (
    <>
      <div className={`bg-gradient-info ${headerClassName}`}>
        <div md={12} className="form-title">
          <i className={iconClass} style={{ color: 'white', fontSize: '35px' }}></i>
          <h1 className="page-title">
            {title}
            {docLink && (
              <a
                href={BASE_URL + docLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ paddingLeft: '10px' }}
              >
                <i className="fa-solid fa-question-circle fa-xs text-white"></i>
              </a>
            )}
          </h1>
        </div>
        {headerChildren}
      </div>

      {description && <div className="page-description">{description}</div>}

      <div className="main-content-area">{children}</div>
    </>
  )
}

export default Header